var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRampLogoSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261.456,
    height: 40.826,
    viewBox: "0 0 261.456 40.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 261.456,
    height: 40.826,
    fill: "#f43411"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31479",
    "data-name": "Group 31479",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31478",
    "data-name": "Group 31478",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11489",
    "data-name": "Path 11489",
    d: "M38.069,22.768c2.364-.276,3.121-1.409,3.121-3.976V8.579c0-1.51-.957-2.617-3.121-2.668V5.584h7.673l4.983,12.429h.126L55.3,5.584h6.844V5.91c-2.038.076-2.516.429-2.516,1.309V21.485c0,.88.478,1.208,2.516,1.283v.353H53.115v-.353c1.559-.075,2.339-.353,2.339-1.283V7.346h-.126L49.643,23.121H48.485L41.969,7.346h-.15V18.792c0,2.567.854,3.675,3.346,3.976v.353h-7.1Z",
    transform: "translate(17.867 2.622)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11490",
    "data-name": "Path 11490",
    d: "M55.414,18.32a3.133,3.133,0,0,1,1.635-2.667c1.76-.957,4.578-.705,5.611-.982V12.407c0-1.71-.5-2.416-1.737-2.416a3.164,3.164,0,0,0-1.685.453,1.918,1.918,0,0,1,.7,1.51,1.71,1.71,0,0,1-1.91,1.862,1.865,1.865,0,0,1-1.913-1.837c0-1.535,1.585-2.491,5.462-2.491,3.3,0,4.93,1.208,4.93,4.151v5.409c0,1.233.5,1.51,1.81.932l.151.276A4.8,4.8,0,0,1,65.6,21.389c-1.712,0-2.441-.654-2.717-1.912h-.1a4.887,4.887,0,0,1-3.75,1.937c-2.516,0-3.622-1.61-3.622-3.094m7.247.629V15.174c-2.517.278-3.171.907-3.171,2.768,0,1.183.63,1.912,1.612,1.912a1.935,1.935,0,0,0,1.559-.905",
    transform: "translate(26.008 4.454)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11491",
    "data-name": "Path 11491",
    d: "M64.317,20.986c1.434-.025,1.71-.276,1.71-.88V11.4c0-.754-.276-1.208-1.71-1.233v-.3l5.535-.3v2.364a4.1,4.1,0,0,1,3.522-2.441,2.183,2.183,0,0,1,2.416,2.264A2.023,2.023,0,0,1,73.8,13.967,2,2,0,0,1,71.664,12a4.064,4.064,0,0,1,.2-1.131A3.11,3.11,0,0,0,69.9,12.431v7.674c0,.6.378.805,2.316.88v.3h-7.9Z",
    transform: "translate(30.187 4.454)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11492",
    "data-name": "Path 11492",
    d: "M77.94,22.1c0,.6.378.855,1.259.88v.3H72.38v-.3c1.409-.025,1.685-.276,1.685-.88V7.079c0-.754-.251-1.206-1.785-1.233v-.3l5.66-.3v12.73l3.2-3.5c1.233-1.358.754-2.063-.78-2.565v-.3h5.813v.3a9.777,9.777,0,0,0-4.681,2.945l-.426.426,4.076,6.164c.854,1.309,1.106,1.409,2.264,1.535v.3H80.382v-.3c1.056-.05,1.231-.3.654-1.258l-2.391-3.9-.705.754Z",
    transform: "translate(33.924 2.461)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11493",
    "data-name": "Path 11493",
    d: "M82.4,15.651a5.874,5.874,0,0,1,6.164-6.214c3.6,0,5.536,2.339,5.359,5.811H86.475v.4c0,3.171,1.283,4.781,3.7,4.781a4.044,4.044,0,0,0,3.421-2.013l.278.175a5.861,5.861,0,0,1-5.284,2.92c-3.672,0-6.189-2.038-6.189-5.863m4.076-.905h3.572c.328-2.92-.251-4.8-1.635-4.8-1.308,0-1.837,1.835-1.937,4.8",
    transform: "translate(38.673 4.43)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11494",
    "data-name": "Path 11494",
    d: "M92.686,19.119v-7.17H90.5v-.478l2.239-.454V7.822L96.56,6.766v4.3h3.547v.83H96.56v7.447c0,1.409.353,2.089,1.485,2.089.805,0,1.359-.479,1.837-1.61l.328.151c-.68,1.885-1.687,2.792-3.726,2.792-2.061,0-3.8-.907-3.8-3.648",
    transform: "translate(42.474 3.176)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11495",
    "data-name": "Path 11495",
    d: "M97.518,22.931c1.434-.025,1.81-.276,1.81-.88V13.345c0-.754-.376-1.208-1.81-1.233v-.3l5.685-.3V22.05c0,.6.226.855,1.685.88v.3h-7.37Zm1.459-15.3a2.139,2.139,0,0,1,2.239-2.289,2.074,2.074,0,0,1,2.239,2.189A2.107,2.107,0,0,1,101.216,9.8a2.042,2.042,0,0,1-2.239-2.164",
    transform: "translate(45.769 2.509)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11496",
    "data-name": "Path 11496",
    d: "M103.064,20.986c1.434-.025,1.712-.276,1.712-.88V11.4c0-.754-.278-1.208-1.712-1.233v-.3l5.535-.3v2.389a5.621,5.621,0,0,1,4.354-2.466c2.239,0,3.2,1.334,3.2,3.748v6.869c0,.6.251.855,1.685.88v.3h-6.843v-.3c.88-.025,1.283-.276,1.283-.88V13.263c0-1.309-.479-2.089-1.61-2.089a2.69,2.69,0,0,0-2.013,1.284v7.648c0,.6.378.855,1.233.88v.3h-6.819Z",
    transform: "translate(48.372 4.454)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11497",
    "data-name": "Path 11497",
    d: "M121.666,10.517a3.5,3.5,0,0,1,2.97-2.467,1.437,1.437,0,0,1,1.61,1.484,1.266,1.266,0,0,1-1.333,1.334,1.46,1.46,0,0,1-1.386-1.509,3.376,3.376,0,0,0-1.408,1.331,3.521,3.521,0,0,1,2.466,3.322c0,2.441-2.214,3.976-5.284,3.976a10.416,10.416,0,0,1-1.61-.128c-1.007.279-1.359.605-1.359,1.109s.605.754,2.089.754h2.945c2.742,0,4.149,1.007,4.149,3.019,0,2.289-2.69,4.251-6.716,4.251-3.121,0-5.46-.929-5.46-2.388,0-1.059.729-1.687,2.742-1.988v-.05a2.741,2.741,0,0,1-2.113-2.518c0-.829,1.006-1.96,2.943-2.363a3.647,3.647,0,0,1-2.918-3.573c0-2.416,2.213-3.95,5.309-3.95a7.715,7.715,0,0,1,2.364.353M123.05,24.1c0-.9-.627-1.458-2.692-1.458h-3.673a1.953,1.953,0,0,0-.93,1.659c0,1.61,1.283,2.239,3.7,2.239,2.138,0,3.6-.88,3.6-2.441m-2.138-10.039c0-2.188-.428-3.446-1.737-3.446-1.256,0-1.508,1.006-1.508,3.446s.451,3.472,1.734,3.472c1.233,0,1.51-1.03,1.51-3.472",
    transform: "translate(53.194 3.779)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11498",
    "data-name": "Path 11498",
    d: "M132.068,21.485c0,.932.779,1.208,2.364,1.284v.351h-9.107v-.351c2.036-.076,2.516-.4,2.516-1.284V7.221c0-.882-.479-1.234-2.516-1.309V5.584h9.082c5.282,0,7.044,1.988,7.044,4.252,0,2.139-1.333,3.7-5.334,4.277v.076c3.7.075,4.756,1.71,5.031,3.925l.178,2.341c.251,1.912.579,2.213,2.592,2.289v.326a21.081,21.081,0,0,1-2.693.151c-3.521,0-4.051-.982-4.226-3.146l-.176-2.113c-.226-2.565-.907-3.547-3.7-3.547h-1.056Zm1.433-7.472c2.945,0,3.623-.88,3.623-3.9,0-2.592-.905-4.1-3.848-4.1h-1.208v8Z",
    transform: "translate(58.82 2.622)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11499",
    "data-name": "Path 11499",
    d: "M138.132,18.32a3.135,3.135,0,0,1,1.634-2.667c1.762-.957,4.58-.705,5.611-.982V12.407c0-1.71-.5-2.416-1.735-2.416a3.164,3.164,0,0,0-1.685.453,1.918,1.918,0,0,1,.7,1.51,1.71,1.71,0,0,1-1.91,1.862,1.865,1.865,0,0,1-1.913-1.837c0-1.535,1.585-2.491,5.46-2.491,3.3,0,4.931,1.208,4.931,4.151v5.409c0,1.233.5,1.51,1.81.932l.151.276a4.8,4.8,0,0,1-2.867,1.133c-1.712,0-2.442-.654-2.718-1.912h-.1a4.889,4.889,0,0,1-3.75,1.937c-2.516,0-3.622-1.61-3.622-3.094m7.245.629V15.174c-2.516.278-3.169.907-3.169,2.768,0,1.183.629,1.912,1.61,1.912a1.931,1.931,0,0,0,1.559-.905",
    transform: "translate(64.831 4.454)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11500",
    "data-name": "Path 11500",
    d: "M154.962,20.986c.905-.025,1.131-.276,1.131-.88V13.263c0-1.309-.529-2.089-1.685-2.089-.754,0-1.156.5-1.785,1.284v7.648c0,.6.226.855,1.106.88v.3h-6.694v-.3c1.436-.025,1.713-.276,1.713-.88V11.4c0-.754-.278-1.208-1.713-1.233v-.3l5.536-.3v2.389a5.232,5.232,0,0,1,4.152-2.466,2.862,2.862,0,0,1,3.144,2.617,5.54,5.54,0,0,1,4.2-2.617c2.241,0,3.272,1.334,3.272,3.748v6.869c0,.6.251.855,1.685.88v.3h-6.694v-.3c.882-.025,1.134-.276,1.134-.88V13.263c0-1.309-.429-2.089-1.585-2.089a3.094,3.094,0,0,0-1.937,1.434c.023.3.023.454.023.629v6.869c0,.6.251.855,1.108.88v.3h-6.114Z",
    transform: "translate(69.009 4.454)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11501",
    "data-name": "Path 11501",
    d: "M162.145,25.767c1.434-.026,1.685-.278,1.685-.882V11.425c0-.754-.276-1.208-1.71-1.233v-.3l5.535-.3v1.486a5.6,5.6,0,0,1,3.672-1.637c3,0,4.68,2.341,4.68,5.938,0,3.347-1.91,6.14-5.382,6.14a7.205,7.205,0,0,1-2.92-.529v3.9c0,.6.4.805,2.339.882v.3h-7.9Zm9.787-10.241c0-2.617-.605-4.78-2.391-4.78a3.314,3.314,0,0,0-1.837.679v8.127a2.268,2.268,0,0,0,2.139,1.459c1.283,0,2.088-1.737,2.088-5.485",
    transform: "translate(76.089 4.43)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11502",
    "data-name": "Path 11502",
    d: "M172.667,8.852a3.875,3.875,0,0,1,7.749,0,3.875,3.875,0,1,1-7.749,0m7.373,0A3.388,3.388,0,0,0,176.518,5.3a3.348,3.348,0,0,0-3.472,3.547,3.39,3.39,0,0,0,3.472,3.6,3.429,3.429,0,0,0,3.522-3.6m-3.875,1.434c0,.226.15.326.527.326v.178h-2.088v-.178c.428,0,.577-.125.577-.326V7.191c0-.2-.15-.276-.577-.276v-.2h2.013c1.459,0,1.812.453,1.812.982s-.251.855-1.183.98v.076c.83.125,1.005.326,1.056.83l.051.554c.025.351.226.453.577.453v.175a2.884,2.884,0,0,1-.729.076c-.629,0-.857-.228-.882-.78l-.024-.453c-.026-.579-.228-.78-.73-.78h-.4Zm.428-1.66c.6,0,.754-.251.754-.905,0-.579-.175-.805-.805-.805h-.376v1.71Z",
    transform: "translate(81.039 2.348)",
    fill: "#f43411"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Marketing_RAMP_Logo",
    "data-name": "Marketing RAMP Logo",
    transform: "translate(1.691 2.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13793",
    "data-name": "Path 13793",
    d: "M210.39,1052.5l3.021-1.63,17.608,12.166v3.717Z",
    transform: "translate(-209.491 -1029.792)",
    fill: "#58a55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13794",
    "data-name": "Path 13794",
    d: "M319.066,994.31l14.613,10.009v3.773L316.07,995.927Z",
    transform: "translate(-312.15 -974.849)",
    fill: "#2d6a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13795",
    "data-name": "Path 13795",
    d: "M319.066,994.31l14.613,10.009v3.773L316.07,995.927Z",
    transform: "translate(-312.15 -974.849)",
    fill: "#a9c954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13796",
    "data-name": "Path 13796",
    d: "M1009.438,320.819,998.225,313.5l-10.315,6.762v3.852l10.315-6.762,8.3,5.307V333.3l2.91,1.516Z",
    transform: "translate(-964.786 -313.5)",
    fill: "#a14d89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13797",
    "data-name": "Path 13797",
    d: "M998.225,448.26l-10.315,6.762v3.638l10.272-6.805,5.093,3.06v3.852l-.068,3.832,3.32,1.607V453.567Z",
    transform: "translate(-964.786 -444.408)",
    fill: "#cb83b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13798",
    "data-name": "Path 13798",
    d: "M178.95,320.819l11.214-7.319,10.315,6.762v3.852l-10.315-6.762-8.3,5.307V333.3l-2.91,1.516Z",
    transform: "translate(-178.95 -313.5)",
    fill: "#ec9d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13799",
    "data-name": "Path 13799",
    d: "M289.063,448.26l10.315,6.762v3.638l-10.272-6.805-5.093,3.06v3.852l.042,3.825-3.295,1.614V453.567Z",
    transform: "translate(-277.85 -444.408)",
    fill: "#f8c946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13800",
    "data-name": "Path 13800",
    d: "M466.281,653.09l14.511-9.945v-6.754l-3.382-2.141-11.129,7.293-11.13-7.293-3.381,2.141v6.754Z",
    transform: "translate(-443.972 -625.081)",
    fill: "#dd4b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13801",
    "data-name": "Path 13801",
    d: "M1005.519,1050.87l-17.609,12.166v3.717l20.629-14.252",
    transform: "translate(-964.786 -1029.792)",
    fill: "#5c89b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13802",
    "data-name": "Path 13802",
    d: "M1002.523,994.31l-14.613,10.009v3.773l17.609-12.165Z",
    transform: "translate(-964.786 -974.849)",
    fill: "#2d6a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13803",
    "data-name": "Path 13803",
    d: "M1002.523,994.31l-14.613,10.009v3.773l17.609-12.165Z",
    transform: "translate(-964.786 -974.849)",
    fill: "#50b6d9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRampLogoSm);
export default __webpack_public_path__ + "static/media/ramp-logo-sm.ad04ede003b6d89fe27dabc67e885274.svg";
export { ForwardRef as ReactComponent };